<template>
    <div>
      <StatusBasedCases :selectedBilledStatuses="statuses" :selectedSubStatuses="subStatuses"></StatusBasedCases>
    </div>
  </template>
    
    <script>
  const StatusBasedCases = defineAsyncComponent(() =>
    import("@/components/cases/AllCases")
  );
  import { defineAsyncComponent } from "vue";
  export default {
    components: {
        StatusBasedCases,
    },
    data() {
    return {
      statuses: "Exception Reviewed",
    };
  },
  };
  </script>
    